import { useQuery } from '@tanstack/react-query';
import { fetchAnalyticsPages, type AnalyticsPagesRequest } from '@/utils/analyticsPagesAPI';
import type { ListResponse } from '@/components/reports/lists/types';

export function useAnalyticsPages(
  config: Omit<AnalyticsPagesRequest, 'pagination'> | null,
  offset: number = 0
) {
  return useQuery<ListResponse, Error>({
    queryKey: ['analytics-pages', config, offset],
    queryFn: async () => {
      if (!config) throw new Error('Configuration required');

      const paginationConfig: { limit: number; offset?: number } = {
        limit: 50,
      };

      // Only include offset if it's greater than 0
      if (offset > 0) {
        paginationConfig.offset = offset;
      }

      return fetchAnalyticsPages({
        ...config,
        pagination: paginationConfig
      });
    },
    enabled: !!config && (!!config.period || !!config.periods),
    staleTime: 5 * 60 * 1000,  // 5 minutes
    gcTime: 30 * 60 * 1000,    // 30 minutes (formerly cacheTime)
    retry: 3,  // Increased retry count to handle transient 546 errors
  });
}
